import React from 'react';
import PropTypes from 'prop-types';
import { EachRecommendedCourse } from './EachCourse.styles';
import { useNavigate } from 'react-router-dom';

const EachRecommended = ({ courses, course: cI }) => {
  const navigate = useNavigate();
  const handleCourseClick = (courseId) => {
    navigate(`/course/${courseId}`);
  };
  const filteredCourses = courses
    ?.filter((c) => c?.tags?.some((tag) => cI?.tags?.includes(tag)))
    .slice(0, 15);
  return (
    <div style={{ display: 'flex', gap: '1rem' }}>
      {filteredCourses?.map((c) => {
        if (c?._id !== cI?._id) {
          return (
            <EachRecommendedCourse
              key={c?._id}
              onClick={() => handleCourseClick(c?._id)}
            >
              <img src={c?.image} alt={c?.courseName} />
              <h4>{c?.courseName.slice(0, 17)}</h4>
              <span>${c?.price}</span>
            </EachRecommendedCourse>
          );
        }
      })}
    </div>
  );
};
EachRecommended.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      courseName: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
      price: PropTypes.number,
    })
  ),
  course: PropTypes.shape({
    _id: PropTypes.string,
    courseName: PropTypes.string,
    description: PropTypes.string,
    image: PropTypes.string,
    price: PropTypes.number,
    tags: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default EachRecommended;
